module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"shared":{"users":{"advisor_classification":{"asset_managers":"Wealth Manager","banks":"Banking Consultant","banks_institutional":"Institutional Sales Consultant","fee_only_financial_advisor":"Fee only Financial Advisor","financial_broker":"Financial Broker"}}}}}}')
  delete Component.options._Ctor
}
